import actionTypes from '../constants/action-types';

const clearBlocksHtml = () => ({
  type: actionTypes.CLEAR_BLOCKS_HTML,
});

export default clearBlocksHtml;
